import { simulateClick } from "@leafly-com/web-utils";
import classNames from "classnames";
import Link from "next/link";

import { Action } from "@/constants/events";
import useDomainCountryCode from "@/hooks/useDomainCountryCode";
import { useEventTracker } from "@/hooks/useEventTracker";
import { dispensaryHref } from "@/utils/dispensaryUrls";

const ShopAllButton: React.FC<{
  className?: string;
  dispensarySlug: string;
  dispensaryRetailType: string;
}> = ({ className, dispensarySlug, dispensaryRetailType }) => {
  const { publishEvent } = useEventTracker();
  const countryCode = useDomainCountryCode();

  const href = dispensaryHref({
    additionalPath: "/menu",
    countryCode,
    retailType: dispensaryRetailType,
    slug: dispensarySlug,
  });

  const trackButtonClick = () =>
    publishEvent({
      action: Action.Click,
      category: "Dispensary Menu",
      label: "Shop All Products Button",
    });

  return (
    <div
      data-testid="shop-all-button"
      className={classNames("row px-md", className)}
    >
      <Link
        data-testid="shop-all-link"
        href={href}
        role="button"
        onClick={trackButtonClick}
        onKeyDown={simulateClick}
        className="button button--secondary"
      >
        shop all products
      </Link>
    </div>
  );
};

export default ShopAllButton;
